import React from 'react';
import { Slot } from '@radix-ui/react-slot';
import clsx from 'clsx';

const Button = React.forwardRef(({ asChild, className, variant = 'primary', size = 'lg', ...props }, ref) => {
  const Comp = asChild ? Slot : 'button';
  return (
    <Comp
      ref={ref}
      className={clsx(
        'vs-btn',
        variant === 'primary' && 'vs-btn-primary',
        className,
      )}
      {...props}
    />
  );
});

export default Button;


